<template>
  <v-app :style="appStyle">
    <v-toolbar app>
      <v-btn icon :to="toolbar.route">
        <v-icon>{{ toolbar.icon }}</v-icon>
      </v-btn>
      <v-toolbar-title>ANRE</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click.stop="fontExtension = !fontExtension">
        <v-icon>format_size</v-icon>
      </v-btn>
      <v-btn icon @click.stop="rightDrawer = !rightDrawer">
        <v-icon>menu</v-icon>
      </v-btn>

      <template slot="extension" v-if="fontExtension">
        <v-slider
          v-model="fontSize"
          :tick-labels="fontSizes"
          min="0.8"
          max="1.4"
          step="0.2"
          ticks="always"
        ></v-slider>
      </template>
    </v-toolbar>
    <v-content>
      <router-view :key="language"/>
    </v-content>
    <v-navigation-drawer
      temporary
      v-model="rightDrawer"
      right
      fixed
      app
    >
      <v-list dense>
        <language-menu></language-menu>
        <notifications-menu></notifications-menu>
        <v-list-tile :to="{ name: 'pagini.show', params: { slug: termsPageSlug } }">
          <v-list-tile-content>
            <v-list-tile-title>{{ termsPageTitle }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-footer app>
      <v-layout justify-center row wrap>
        <v-flex text-xs-center xs12 class="text-xs-center">
          &copy; ANRE {{ year }}. {{ copyright }}
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
  import { mapGetters } from 'vuex';
  import keywords from '@/modules/home/lang/index.js';
  import LanguageMenu from './LanguageMenu.vue';
  import NotificationsMenu from './NotificationsMenu.vue';
  import {ping} from '@/modules/common.js';

  export default {
    name: 'App',
    data() {
      return {
        rightDrawer: false,
        fontExtension: false,
        fontSizes: [
          'x0.8',
          'x1.0',
          'x1.2',
          'x1.4',
        ]
      }
    },
    computed: {
      ...mapGetters(['language']),
      appStyle() {
        return {
          fontSize: this.fontSize + 'em',
          // transform: `scale(${this.fontSize})`,
        }
      },
      keywords() {
        return keywords[this.language]
      },
      termsPageTitle() {
        return this.keywords.termeni_si_conditii;
      },
      termsPageSlug() {
        return this.keywords.pagina_termeni_si_conditii;
      },
      copyright() {
        return this.keywords.copyright;
      },
      bc() {
        return this.$route.matched
          .filter(route => route.meta.bc !== undefined)
          .map(route => ({
            name: route.meta.bc || route.name,
            params: this.$route.params
          }));
      },
      parent() {
        return this.bc[this.bc.length - 2] || this.bc[0]
      },
      toolbar() {
        return {
          icon: this.bc.length > 1 ? 'arrow_back' : 'home',
          route: this.parent
        };
      },
      year() {
        return new Date().getFullYear()
      },
      fontSize: {
        get() {
          return this.$store.state.fontSize;
        },
        set(v) {
          this.$store.dispatch('setFontSize', v);
        }
      }
    },
    mounted() {
      ping()
        .catch(e => {
          console.log(e);
        })
    },
    components: {
      NotificationsMenu,
      LanguageMenu
    }
  }
</script>
